<template>
	<div ref="timelineTooltipElementRef" class="timelineTooltip flex h-full w-full items-center justify-center" @mouseenter="show" @mouseleave="hide">
		<slot />
	</div>

	<MbscPopup
		v-if="!hideContent && timelineTooltipElementRef && isTooltipVisible"
		css-class="timelineTooltipPopup"
		display="anchored"
		:anchor="timelineTooltipElementRef"
		:touch-ui="false"
		:show-overlay="false"
		:content-padding="false"
		:close-on-overlay-click="false"
		:scroll-lock="false"
		:max-width="maxWidth"
		theme="no-theme"
		:animation="false"
		is-open
	>
		<div class="timelineTooltipContent">
			<div v-if="slots.title" class="timelineTooltipContentTitle font-body-s-medium mb-03">
				<slot name="title" />
			</div>

			<div class="timelineTooltipContentBody whitespace-break-spaces">
				<slot name="content" />
			</div>
		</div>
	</MbscPopup>
</template>

<script setup lang="ts">
import { MbscPopup } from '@mobiscroll/vue'
import { useSlots, ref } from 'vue'

const props = withDefaults(
	defineProps<{
		hideContent?: boolean
		delay?: number
		maxWidth?: number
	}>(),
	{
		delay: 200,
		maxWidth: 350
	}
)

const slots = useSlots()

const isTooltipVisible = ref(false)
const timelineTooltipElementRef = ref<HTMLDivElement>()

let timeoutId: number | undefined

function show() {
	timeoutId = window.setTimeout(() => {
		isTooltipVisible.value = true
	}, props.delay)
}

function hide() {
	window.clearTimeout(timeoutId)
	isTooltipVisible.value = false
}
</script>

<style lang="scss">
@import '@bluebrick/saas-ui/saas-ui.css';

.timelineTooltipPopup .mbsc-popup-body {
	@apply font-body-s rounded bg-level-00;

	border: var(--border);
	border-color: theme('colors.level.02');
	box-shadow: theme('boxShadow.1');
	color: theme('textColor.normal');
	padding: 0;
}

.timelineTooltipPopup .mbsc-popup-arrow-wrapper-top,
.timelineTooltipPopup .mbsc-popup-arrow-wrapper-bottom {
	height: 0.75rem;
}

.timelineTooltipPopup .mbsc-popup-arrow {
	@apply bg-level-02;
}

.timelineTooltipPopup .mbsc-popup-arrow-bottom {
	top: 0.75rem;
}

.timelineTooltipPopup .mbsc-popup-arrow-top {
	bottom: 0.75em;
}

.timelineTooltipPopup .mbsc-popup-content {
	padding: theme('spacing.05');
}
</style>
